module.exports = __webpack_public_path__ + "media/images/google_calendar-76874ef06d3baf6da775823185779b86.svg";